// extracted by mini-css-extract-plugin
export default {"basicForm":"style_basicForm__07JMG","languagePreference":"style_languagePreference__1korS","arrowRightIcon":"style_arrowRightIcon__xQwT3","signinLink":"style_signinLink__EdX66"};